import { put, takeLatest } from 'redux-saga/effects';
import api from '../../../../utils/apiConfig';
import OperatorUndertaking from './types';
import {
  fetchOperatorBasicDetailsSuccess,
  fetchOperatorBasicDetailsFailure,
  initiateOperatorUndertakingSuccess,
  initiateOperatorUndertakingFailure,
} from './actions';
import urlHelper from './urls';

function* getOperatorTdsDetailsSaga(action: any) {
  const requestURL: any = urlHelper.getOperatordetails(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchOperatorBasicDetailsSuccess(response));
  } catch (e) {
    yield put(fetchOperatorBasicDetailsFailure(e));
    console.log({ e });
  }
}

function* getInitiateUndertakingSaga(action: any) {
  const requestURL = urlHelper.initiateUndertaking(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(initiateOperatorUndertakingSuccess(response));
  } catch (e) {
    yield put(initiateOperatorUndertakingFailure(e));
    console.log({ e });
  }
}

function* operatorUndertakingSaga() {
  yield takeLatest(OperatorUndertaking.FETCH_OPERATOR_BASIC_DETAILS_START, getOperatorTdsDetailsSaga);
  yield takeLatest(OperatorUndertaking.INITIATE_OPERATOR_UNDERTAKING_START, getInitiateUndertakingSaga);
}
export default operatorUndertakingSaga;
